import {DataTable} from 'pepsico-ds'

const columns = [
  {columnKey: 'Description', header: 'Description'},
  {columnKey: 'PointsAwarded', header: 'Points Awarded'},
  {columnKey: 'StartDate', header: 'Start Date'},
  {columnKey: 'EndDate', header: 'End Date'},
  {columnKey: 'Status', header: 'Status'},
]

const tableData = [
  {
    Description: 'Login Activity',
    PointsAwarded: '5',
    StartDate: '2024-11-05',
    EndDate: '2024-11-18',
    Status: 'Active',
  },
  {
    Description: 'Welcom Activity',
    PointsAwarded: '500',
    StartDate: '2024-10-15',
    EndDate: '2024-10-28',
    Status: 'Completed',
  },
  {
    Description: 'Points On Delivery',
    PointsAwarded: '205',
    StartDate: '2024-11-15',
    EndDate: '2024-11-28',
    Status: 'Completed',
  },
]

const filters = [
  {
    disabled: false,
    label: 'Status',
    //listLabel: 'Header',
    onChange: () => {},
    options: [
      {id: '1', label: 'Active'},
      {id: '3', label: 'Completed'},
    ],
  },
]

const Activities = () => {
  return (
    <DataTable
      columns={columns}
      data={tableData}
      isDark={true}
      isExpandable={false}
      pageIndex={0}
      pageSize={10}
      selection="single"
      size="large"
      tableHeader=""
      tableDescription=""
      filters={filters}
      toolbarActions={[
        {
          text: 'Download',
          variant: 'secondary',
          onClick: () => alert('Download button clicked'),
        },
      ]}
    />
  )
}

export default Activities
